import {ScreenType as ST} from '@shopping-angular-components/common-library';

export const ScreenType = ST;
export type ScreenType = ST;
